// Classes.
import {BooleanLocatorComponent} from './boolean.locator-component';


export class NewsPopularLocatorComponent extends BooleanLocatorComponent {

  public constructor(_value: boolean = false) {
    super(_value);
  };

  public toString(): string {
    return this._value ? 'popular' : 'all';
  }

  /**
   * isTeam setter/getter.
   */
  set isPopular(isPopular: boolean) {
    this._value = isPopular;
  }

  get isPopular(): boolean {
    return this._value;
  }
}
